import { AccountInfo } from './AccountInfo';
import { connect } from 'react-redux';
import { accountViewActions } from 'src/store/modules/accountview';
import { userDataSel,userActions } from 'src/store/modules/user';
import { withI18n } from 'react-i18next';
import { signInActions } from 'src/store/modules/signin';

const mapStateToProps = (state: any) => {
  return {
    userData: userDataSel(state),
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  signout: () => dispatch(signInActions.signout()),
  getUserDetails: () => dispatch(userActions.getUserDetails())
    
});

// const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
//   onSelect: (selected: string) => dispatch(accountViewActions.setMenuOption(selected))
// });

export const pureComponent = AccountInfo;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(AccountInfo));

interface IDispatchFromProps {
  signout(): void;
  getUserDetails():void;
  
}
